import React from "react";

interface ChatLoadingSkeletonProps {
  showBigChatBox: boolean,
  sidebarCollapsed: boolean
}

const ChatLoadingSkeleton: React.FC<ChatLoadingSkeletonProps> = ({ showBigChatBox, sidebarCollapsed }) => {
  const rows = Array.from({ length: 14 });

  return (
    <div className={`flex flex-col w-full h-full overflow-hidden relative`}>
      {/* Top blur shadow */}
      <div className="absolute top-0 left-0 right-0 h-8 bg-gradient-to-b from-white via-white/80 to-transparent dark:from-gray-900 dark:via-gray-900/80 dark:to-transparent z-10 pointer-events-none"/>

      {/* Chat Loading Skeleton */}
      <div
        className={`flex-1 overflow-hidden`}
      >
        <div
          className={`h-full w-full overflow-hidden overflow-y-hidden py-4 space-y-4
            ${showBigChatBox && sidebarCollapsed ? 'min-w-[60%] max-w-[60%] px-8 mx-auto' : 'w-full px-8'}
            ${showBigChatBox && !sidebarCollapsed ? 'min-w-[80%] max-w-[80%] px-8 mx-auto' : 'w-full px-8'}
          `}
        >
          {rows.map((_, i) => (
            <div key={i} className={`flex w-full py-2 sm:py-3 text-gray-400 text-xs sm:text-sm ${i % 2 === 0 ? 'chat-message bot-message' : 'justify-end user-message'}`}>
              {i % 2 === 0 ? (
                <>
                  <div className="mr-1.5 sm:mr-2 h-6 w-6 sm:h-8 sm:w-8 flex-shrink-0 relative">
                    <div className="h-6 w-6 sm:h-7 sm:w-7 mt-0.5 sm:mt-1 rounded-full bg-gray-200 dark:bg-gray-700 animate-pulse"></div>
                  </div>
                  <div className="flex-1 w-full space-y-2">
                    <div className={`h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse ${i % 4 === 0 ? 'w-4/5' : 'w-3/4'}`}></div>
                    <div className={`h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse ${i % 3 === 0 ? 'w-5/6' : 'w-2/3'}`}></div>
                    {i % 2 === 0 && <div className="w-1/2 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>}
                  </div>
                </>
              ) : (
                <div className="max-w-[85%] sm:max-w-[75%] px-2 sm:px-3 py-1.5 sm:py-2 rounded-2xl sm:rounded-3xl bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
                  <div className={`h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse ${i % 3 === 0 ? 'w-40 sm:w-56' : 'w-24 sm:w-32'}`}></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

       {/*Loading indicator at bottom*/}
      <div className="flex items-center my-8 justify-center">
        <div className="flex items-center space-x-2 text-gray-500 dark:text-gray-400">
          <div className="w-2 h-2 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
          <div className="w-2 h-2 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
          <span className="text-sm ml-2">Loading chat history...</span>
        </div>
      </div>
    </div>
  );
}

export default ChatLoadingSkeleton;